export default [
  {
    "CARD_CODE": "238108406227136980",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "11764368047",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "63791993674",
    "IMSI": "47284305522",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "41-19-16-17-1A-65",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "13612352012",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "DE2CE722B024404F84833FCC637E8390",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "65-15-25-2E-75-18",
    "S_SSID": "fcgz,dmglk",
    "error": {},
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "889660286266975581",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "97467951303",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "11559812591",
    "IMSI": "82717881707",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "0B-6A-5B-02-3E-54",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "27015390391",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "660967A3DEE94DE0A43685175DA99380",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "00-28-0C-4C-01-02,68-37-61-00-1C-49",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "685677147221948102",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "73967164094",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "93060947563",
    "IMSI": "80392787004",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "69-0F-55-1C-4A-2F",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "95152159162",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "1BB2EDAF17074254AFA8ABDA39C7556Dasdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "11-36-35-66-4A-63,6E-23-6B-37-12-61",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "404836102017628519",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "68338747001",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "62554815461",
    "IMSI": "72640078530",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "6A-39-2B-60-30-49",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "92602526296",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "348FE036DFFE4A698C41FFA958EE4BBFasdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "70-29-03-7F-53-49,76-69-1C-7F-7C-7A",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "319968905386866257",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "17260541332",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "91187166541",
    "IMSI": "60948549501",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "2A-70-40-6D-2C-57",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "52186387903",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "BD740786B21A43018D54C07B2DC6B9B5asdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "18-3D-57-2B-7E-62,0A-4E-27-42-11-5B",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "119054125309017233",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "82818336298",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "48956426003",
    "IMSI": "41003669080",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "41-57-51-57-51-00",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "51978031096",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "E2A954170C884B33836D6400874D145Aasdwdadzxc",
    "START_TIME": "00:00",
    "STATION": "test-1636616178",
    "S_MAC": "20-37-5F-3D-74-42,78-38-7C-74-43-0D",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "810883138577086846",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "16875179363",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "13528467478asdsacxzczxcw",
    "IMSI": "61243108555asdsacxzczxcw",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "6B-16-37-2C-1F-24",
    "MODEL": "baiJAIHlXaaaaaaaaaaaaaaaaaaaaaa",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "57221873716",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "90A4C92AB68D443E982A78B257602B01asdwdadzxc",
    "START_TIME": "27:00",
    "STATION": "test-1636616178",
    "S_MAC": "28-60-7F-13-7B-10,03-4A-4E-0C-67-17",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "IMEI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "IMSI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "889220991389700844qwewqewq",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "75909043503",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "48894397851asdsacxzczxcw",
    "IMSI": "90544253182asdsacxzczxcw",
    "LATITUDE": "23.096117asdasd",
    "LONGITUDE": "112.488113asdasd",
    "MAC": "55-55-64-26-5A-25",
    "MODEL": "baiJAIHlXaaaaaaaaaaaaaaaaaaaaaa",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "56236548327",
    "POWER": "-411",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "F6458F638BF6465997F2DB78BA491294asdwdadzxc",
    "START_TIME": "27:00",
    "STATION": "test-1636616178",
    "S_MAC": "27-76-7D-36-26-23,28-33-78-5A-6B-74",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "CARD_CODE": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于18位。",
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "IMEI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "IMSI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "LATITUDE": "字段格式有误，请检查字段格式，精度少于小数点后6位",
      "LONGITUDE": "字段格式有误，请检查字段格式，精度少于小数点后6位",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "238108406227136980",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "11764368047",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "63791993674",
    "IMSI": "47284305522",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "41-19-16-17-1A-65",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "13612352012",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "DE2CE722B024404F84833FCC637E8390",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "65-15-25-2E-75-18",
    "S_SSID": "fcgz,dmglk",
    "error": {},
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "889660286266975581",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "97467951303",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "11559812591",
    "IMSI": "82717881707",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "0B-6A-5B-02-3E-54",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "27015390391",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "660967A3DEE94DE0A43685175DA99380",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "00-28-0C-4C-01-02,68-37-61-00-1C-49",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "685677147221948102",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "73967164094",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "93060947563",
    "IMSI": "80392787004",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "69-0F-55-1C-4A-2F",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "95152159162",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "1BB2EDAF17074254AFA8ABDA39C7556Dasdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "11-36-35-66-4A-63,6E-23-6B-37-12-61",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "404836102017628519",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "68338747001",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "62554815461",
    "IMSI": "72640078530",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "6A-39-2B-60-30-49",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "92602526296",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "348FE036DFFE4A698C41FFA958EE4BBFasdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "70-29-03-7F-53-49,76-69-1C-7F-7C-7A",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "319968905386866257",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "17260541332",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "91187166541",
    "IMSI": "60948549501",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "2A-70-40-6D-2C-57",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "52186387903",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "BD740786B21A43018D54C07B2DC6B9B5asdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "18-3D-57-2B-7E-62,0A-4E-27-42-11-5B",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "119054125309017233",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "82818336298",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "48956426003",
    "IMSI": "41003669080",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "41-57-51-57-51-00",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "51978031096",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "E2A954170C884B33836D6400874D145Aasdwdadzxc",
    "START_TIME": "00:00",
    "STATION": "test-1636616178",
    "S_MAC": "20-37-5F-3D-74-42,78-38-7C-74-43-0D",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "810883138577086846",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "16875179363",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "13528467478asdsacxzczxcw",
    "IMSI": "61243108555asdsacxzczxcw",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "6B-16-37-2C-1F-24",
    "MODEL": "baiJAIHlXaaaaaaaaaaaaaaaaaaaaaa",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "57221873716",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "90A4C92AB68D443E982A78B257602B01asdwdadzxc",
    "START_TIME": "27:00",
    "STATION": "test-1636616178",
    "S_MAC": "28-60-7F-13-7B-10,03-4A-4E-0C-67-17",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "IMEI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "IMSI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "889220991389700844qwewqewq",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "75909043503",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "48894397851asdsacxzczxcw",
    "IMSI": "90544253182asdsacxzczxcw",
    "LATITUDE": "23.096117asdasd",
    "LONGITUDE": "112.488113asdasd",
    "MAC": "55-55-64-26-5A-25",
    "MODEL": "baiJAIHlXaaaaaaaaaaaaaaaaaaaaaa",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "56236548327",
    "POWER": "-411",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "F6458F638BF6465997F2DB78BA491294asdwdadzxc",
    "START_TIME": "27:00",
    "STATION": "test-1636616178",
    "S_MAC": "27-76-7D-36-26-23,28-33-78-5A-6B-74",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "CARD_CODE": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于18位。",
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "IMEI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "IMSI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "LATITUDE": "字段格式有误，请检查字段格式，精度少于小数点后6位",
      "LONGITUDE": "字段格式有误，请检查字段格式，精度少于小数点后6位",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "238108406227136980",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "11764368047",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "63791993674",
    "IMSI": "47284305522",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "41-19-16-17-1A-65",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "13612352012",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "DE2CE722B024404F84833FCC637E8390",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "65-15-25-2E-75-18",
    "S_SSID": "fcgz,dmglk",
    "error": {},
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "889660286266975581",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "97467951303",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "11559812591",
    "IMSI": "82717881707",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "0B-6A-5B-02-3E-54",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "27015390391",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "660967A3DEE94DE0A43685175DA99380",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "00-28-0C-4C-01-02,68-37-61-00-1C-49",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "685677147221948102",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "73967164094",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "93060947563",
    "IMSI": "80392787004",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "69-0F-55-1C-4A-2F",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "95152159162",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "1BB2EDAF17074254AFA8ABDA39C7556Dasdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "11-36-35-66-4A-63,6E-23-6B-37-12-61",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "404836102017628519",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "68338747001",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "62554815461",
    "IMSI": "72640078530",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "6A-39-2B-60-30-49",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "92602526296",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "348FE036DFFE4A698C41FFA958EE4BBFasdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "70-29-03-7F-53-49,76-69-1C-7F-7C-7A",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "319968905386866257",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "17260541332",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "91187166541",
    "IMSI": "60948549501",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "2A-70-40-6D-2C-57",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "52186387903",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "BD740786B21A43018D54C07B2DC6B9B5asdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "18-3D-57-2B-7E-62,0A-4E-27-42-11-5B",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "119054125309017233",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "82818336298",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "48956426003",
    "IMSI": "41003669080",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "41-57-51-57-51-00",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "51978031096",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "E2A954170C884B33836D6400874D145Aasdwdadzxc",
    "START_TIME": "00:00",
    "STATION": "test-1636616178",
    "S_MAC": "20-37-5F-3D-74-42,78-38-7C-74-43-0D",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "810883138577086846",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "16875179363",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "13528467478asdsacxzczxcw",
    "IMSI": "61243108555asdsacxzczxcw",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "6B-16-37-2C-1F-24",
    "MODEL": "baiJAIHlXaaaaaaaaaaaaaaaaaaaaaa",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "57221873716",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "90A4C92AB68D443E982A78B257602B01asdwdadzxc",
    "START_TIME": "27:00",
    "STATION": "test-1636616178",
    "S_MAC": "28-60-7F-13-7B-10,03-4A-4E-0C-67-17",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "IMEI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "IMSI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "889220991389700844qwewqewq",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "75909043503",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "48894397851asdsacxzczxcw",
    "IMSI": "90544253182asdsacxzczxcw",
    "LATITUDE": "23.096117asdasd",
    "LONGITUDE": "112.488113asdasd",
    "MAC": "55-55-64-26-5A-25",
    "MODEL": "baiJAIHlXaaaaaaaaaaaaaaaaaaaaaa",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "56236548327",
    "POWER": "-411",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "F6458F638BF6465997F2DB78BA491294asdwdadzxc",
    "START_TIME": "27:00",
    "STATION": "test-1636616178",
    "S_MAC": "27-76-7D-36-26-23,28-33-78-5A-6B-74",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "CARD_CODE": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于18位。",
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "IMEI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "IMSI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "LATITUDE": "字段格式有误，请检查字段格式，精度少于小数点后6位",
      "LONGITUDE": "字段格式有误，请检查字段格式，精度少于小数点后6位",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "238108406227136980",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "11764368047",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "63791993674",
    "IMSI": "47284305522",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "41-19-16-17-1A-65",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "13612352012",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "DE2CE722B024404F84833FCC637E8390",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "65-15-25-2E-75-18",
    "S_SSID": "fcgz,dmglk",
    "error": {},
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "889660286266975581",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "97467951303",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "11559812591",
    "IMSI": "82717881707",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "0B-6A-5B-02-3E-54",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "27015390391",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "660967A3DEE94DE0A43685175DA99380",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "00-28-0C-4C-01-02,68-37-61-00-1C-49",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "685677147221948102",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "73967164094",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "93060947563",
    "IMSI": "80392787004",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "69-0F-55-1C-4A-2F",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "95152159162",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "1BB2EDAF17074254AFA8ABDA39C7556Dasdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "11-36-35-66-4A-63,6E-23-6B-37-12-61",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "404836102017628519",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "68338747001",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "62554815461",
    "IMSI": "72640078530",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "6A-39-2B-60-30-49",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "92602526296",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "348FE036DFFE4A698C41FFA958EE4BBFasdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "70-29-03-7F-53-49,76-69-1C-7F-7C-7A",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "319968905386866257",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "17260541332",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "91187166541",
    "IMSI": "60948549501",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "2A-70-40-6D-2C-57",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "52186387903",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "BD740786B21A43018D54C07B2DC6B9B5asdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "18-3D-57-2B-7E-62,0A-4E-27-42-11-5B",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "119054125309017233",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "82818336298",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "48956426003",
    "IMSI": "41003669080",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "41-57-51-57-51-00",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "51978031096",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "E2A954170C884B33836D6400874D145Aasdwdadzxc",
    "START_TIME": "00:00",
    "STATION": "test-1636616178",
    "S_MAC": "20-37-5F-3D-74-42,78-38-7C-74-43-0D",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "810883138577086846",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "16875179363",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "13528467478asdsacxzczxcw",
    "IMSI": "61243108555asdsacxzczxcw",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "6B-16-37-2C-1F-24",
    "MODEL": "baiJAIHlXaaaaaaaaaaaaaaaaaaaaaa",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "57221873716",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "90A4C92AB68D443E982A78B257602B01asdwdadzxc",
    "START_TIME": "27:00",
    "STATION": "test-1636616178",
    "S_MAC": "28-60-7F-13-7B-10,03-4A-4E-0C-67-17",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "IMEI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "IMSI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "889220991389700844qwewqewq",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "75909043503",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "48894397851asdsacxzczxcw",
    "IMSI": "90544253182asdsacxzczxcw",
    "LATITUDE": "23.096117asdasd",
    "LONGITUDE": "112.488113asdasd",
    "MAC": "55-55-64-26-5A-25",
    "MODEL": "baiJAIHlXaaaaaaaaaaaaaaaaaaaaaa",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "56236548327",
    "POWER": "-411",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "F6458F638BF6465997F2DB78BA491294asdwdadzxc",
    "START_TIME": "27:00",
    "STATION": "test-1636616178",
    "S_MAC": "27-76-7D-36-26-23,28-33-78-5A-6B-74",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "CARD_CODE": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于18位。",
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "IMEI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "IMSI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "LATITUDE": "字段格式有误，请检查字段格式，精度少于小数点后6位",
      "LONGITUDE": "字段格式有误，请检查字段格式，精度少于小数点后6位",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "238108406227136980",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "11764368047",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "63791993674",
    "IMSI": "47284305522",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "41-19-16-17-1A-65",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "13612352012",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "DE2CE722B024404F84833FCC637E8390",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "65-15-25-2E-75-18",
    "S_SSID": "fcgz,dmglk",
    "error": {},
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "889660286266975581",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "97467951303",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "11559812591",
    "IMSI": "82717881707",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "0B-6A-5B-02-3E-54",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "27015390391",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "660967A3DEE94DE0A43685175DA99380",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "00-28-0C-4C-01-02,68-37-61-00-1C-49",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "685677147221948102",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "73967164094",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "93060947563",
    "IMSI": "80392787004",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "69-0F-55-1C-4A-2F",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "95152159162",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "1BB2EDAF17074254AFA8ABDA39C7556Dasdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "11-36-35-66-4A-63,6E-23-6B-37-12-61",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "404836102017628519",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "68338747001",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "62554815461",
    "IMSI": "72640078530",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "6A-39-2B-60-30-49",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "92602526296",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "348FE036DFFE4A698C41FFA958EE4BBFasdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "70-29-03-7F-53-49,76-69-1C-7F-7C-7A",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "319968905386866257",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "17260541332",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "91187166541",
    "IMSI": "60948549501",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "2A-70-40-6D-2C-57",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "52186387903",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "BD740786B21A43018D54C07B2DC6B9B5asdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "18-3D-57-2B-7E-62,0A-4E-27-42-11-5B",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "119054125309017233",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "82818336298",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "48956426003",
    "IMSI": "41003669080",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "41-57-51-57-51-00",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "51978031096",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "E2A954170C884B33836D6400874D145Aasdwdadzxc",
    "START_TIME": "00:00",
    "STATION": "test-1636616178",
    "S_MAC": "20-37-5F-3D-74-42,78-38-7C-74-43-0D",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "810883138577086846",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "16875179363",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "13528467478asdsacxzczxcw",
    "IMSI": "61243108555asdsacxzczxcw",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "6B-16-37-2C-1F-24",
    "MODEL": "baiJAIHlXaaaaaaaaaaaaaaaaaaaaaa",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "57221873716",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "90A4C92AB68D443E982A78B257602B01asdwdadzxc",
    "START_TIME": "27:00",
    "STATION": "test-1636616178",
    "S_MAC": "28-60-7F-13-7B-10,03-4A-4E-0C-67-17",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "IMEI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "IMSI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "889220991389700844qwewqewq",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "75909043503",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "48894397851asdsacxzczxcw",
    "IMSI": "90544253182asdsacxzczxcw",
    "LATITUDE": "23.096117asdasd",
    "LONGITUDE": "112.488113asdasd",
    "MAC": "55-55-64-26-5A-25",
    "MODEL": "baiJAIHlXaaaaaaaaaaaaaaaaaaaaaa",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "56236548327",
    "POWER": "-411",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "F6458F638BF6465997F2DB78BA491294asdwdadzxc",
    "START_TIME": "27:00",
    "STATION": "test-1636616178",
    "S_MAC": "27-76-7D-36-26-23,28-33-78-5A-6B-74",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "CARD_CODE": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于18位。",
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "IMEI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "IMSI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "LATITUDE": "字段格式有误，请检查字段格式，精度少于小数点后6位",
      "LONGITUDE": "字段格式有误，请检查字段格式，精度少于小数点后6位",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "339712072232851613",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "47104496215",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "24:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "96851696858",
    "IMSI": "47468229906",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "29-44-39-47-39-1F",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "WIN",
    "PHONE": "23793087746",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "1902B78ECE034CD9BCF019F29DC93BD3",
    "START_TIME": "00:00",
    "STATION": "test-1636616178",
    "S_MAC": "53-2E-29-7A-49-44",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "339712072232851613",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "47104496215",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "24:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "96851696858",
    "IMSI": "47468229906",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "29-44-39-47-39-1F",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "WIN",
    "PHONE": "23793087746",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "1902B78ECE034CD9BCF019F29DC93BD3",
    "START_TIME": "00:00",
    "STATION": "test-1636616178",
    "S_MAC": "53-2E-29-7A-49-44",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "339712072232851613",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "47104496215",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "24:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "96851696858",
    "IMSI": "47468229906",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "29-44-39-47-39-1F",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "WIN",
    "PHONE": "23793087746",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "1902B78ECE034CD9BCF019F29DC93BD3",
    "START_TIME": "00:00",
    "STATION": "test-1636616178",
    "S_MAC": "53-2E-29-7A-49-44",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "339712072232851613",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "47104496215",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "24:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "96851696858",
    "IMSI": "47468229906",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "29-44-39-47-39-1F",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "WIN",
    "PHONE": "23793087746",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "1902B78ECE034CD9BCF019F29DC93BD3",
    "START_TIME": "00:00",
    "STATION": "test-1636616178",
    "S_MAC": "53-2E-29-7A-49-44",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "339712072232851613",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "47104496215",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "24:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "96851696858",
    "IMSI": "47468229906",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "29-44-39-47-39-1F",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "WIN",
    "PHONE": "23793087746",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "1902B78ECE034CD9BCF019F29DC93BD3",
    "START_TIME": "00:00",
    "STATION": "test-1636616178",
    "S_MAC": "53-2E-29-7A-49-44",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "238108406227136980",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "11764368047",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "63791993674",
    "IMSI": "47284305522",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "41-19-16-17-1A-65",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "13612352012",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "DE2CE722B024404F84833FCC637E8390",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "65-15-25-2E-75-18",
    "S_SSID": "fcgz,dmglk",
    "error": {},
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "889660286266975581",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "97467951303",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "11559812591",
    "IMSI": "82717881707",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "0B-6A-5B-02-3E-54",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "27015390391",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "660967A3DEE94DE0A43685175DA99380",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "00-28-0C-4C-01-02,68-37-61-00-1C-49",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "685677147221948102",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "73967164094",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "93060947563",
    "IMSI": "80392787004",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "69-0F-55-1C-4A-2F",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "95152159162",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "1BB2EDAF17074254AFA8ABDA39C7556Dasdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "11-36-35-66-4A-63,6E-23-6B-37-12-61",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "404836102017628519",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "68338747001",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "62554815461",
    "IMSI": "72640078530",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "6A-39-2B-60-30-49",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "92602526296",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "348FE036DFFE4A698C41FFA958EE4BBFasdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "70-29-03-7F-53-49,76-69-1C-7F-7C-7A",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "319968905386866257",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "17260541332",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "91187166541",
    "IMSI": "60948549501",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "2A-70-40-6D-2C-57",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "52186387903",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "BD740786B21A43018D54C07B2DC6B9B5asdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "18-3D-57-2B-7E-62,0A-4E-27-42-11-5B",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "119054125309017233",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "82818336298",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "48956426003",
    "IMSI": "41003669080",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "41-57-51-57-51-00",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "51978031096",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "E2A954170C884B33836D6400874D145Aasdwdadzxc",
    "START_TIME": "00:00",
    "STATION": "test-1636616178",
    "S_MAC": "20-37-5F-3D-74-42,78-38-7C-74-43-0D",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "810883138577086846",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "16875179363",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "13528467478asdsacxzczxcw",
    "IMSI": "61243108555asdsacxzczxcw",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "6B-16-37-2C-1F-24",
    "MODEL": "baiJAIHlXaaaaaaaaaaaaaaaaaaaaaa",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "57221873716",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "90A4C92AB68D443E982A78B257602B01asdwdadzxc",
    "START_TIME": "27:00",
    "STATION": "test-1636616178",
    "S_MAC": "28-60-7F-13-7B-10,03-4A-4E-0C-67-17",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "IMEI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "IMSI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "889220991389700844qwewqewq",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "75909043503",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "48894397851asdsacxzczxcw",
    "IMSI": "90544253182asdsacxzczxcw",
    "LATITUDE": "23.096117asdasd",
    "LONGITUDE": "112.488113asdasd",
    "MAC": "55-55-64-26-5A-25",
    "MODEL": "baiJAIHlXaaaaaaaaaaaaaaaaaaaaaa",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "56236548327",
    "POWER": "-411",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "F6458F638BF6465997F2DB78BA491294asdwdadzxc",
    "START_TIME": "27:00",
    "STATION": "test-1636616178",
    "S_MAC": "27-76-7D-36-26-23,28-33-78-5A-6B-74",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "CARD_CODE": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于18位。",
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "IMEI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "IMSI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "LATITUDE": "字段格式有误，请检查字段格式，精度少于小数点后6位",
      "LONGITUDE": "字段格式有误，请检查字段格式，精度少于小数点后6位",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "238108406227136980",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "11764368047",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "63791993674",
    "IMSI": "47284305522",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "41-19-16-17-1A-65",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "13612352012",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "DE2CE722B024404F84833FCC637E8390",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "65-15-25-2E-75-18",
    "S_SSID": "fcgz,dmglk",
    "error": {},
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "889660286266975581",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "97467951303",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "11559812591",
    "IMSI": "82717881707",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "0B-6A-5B-02-3E-54",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "27015390391",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "660967A3DEE94DE0A43685175DA99380",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "00-28-0C-4C-01-02,68-37-61-00-1C-49",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "685677147221948102",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "73967164094",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "93060947563",
    "IMSI": "80392787004",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "69-0F-55-1C-4A-2F",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "95152159162",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "1BB2EDAF17074254AFA8ABDA39C7556Dasdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "11-36-35-66-4A-63,6E-23-6B-37-12-61",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "404836102017628519",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "68338747001",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "62554815461",
    "IMSI": "72640078530",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "6A-39-2B-60-30-49",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "92602526296",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "348FE036DFFE4A698C41FFA958EE4BBFasdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "70-29-03-7F-53-49,76-69-1C-7F-7C-7A",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "319968905386866257",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "17260541332",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "91187166541",
    "IMSI": "60948549501",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "2A-70-40-6D-2C-57",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "52186387903",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "BD740786B21A43018D54C07B2DC6B9B5asdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "18-3D-57-2B-7E-62,0A-4E-27-42-11-5B",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "119054125309017233",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "82818336298",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "48956426003",
    "IMSI": "41003669080",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "41-57-51-57-51-00",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "51978031096",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "E2A954170C884B33836D6400874D145Aasdwdadzxc",
    "START_TIME": "00:00",
    "STATION": "test-1636616178",
    "S_MAC": "20-37-5F-3D-74-42,78-38-7C-74-43-0D",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "810883138577086846",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "16875179363",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "13528467478asdsacxzczxcw",
    "IMSI": "61243108555asdsacxzczxcw",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "6B-16-37-2C-1F-24",
    "MODEL": "baiJAIHlXaaaaaaaaaaaaaaaaaaaaaa",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "57221873716",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "90A4C92AB68D443E982A78B257602B01asdwdadzxc",
    "START_TIME": "27:00",
    "STATION": "test-1636616178",
    "S_MAC": "28-60-7F-13-7B-10,03-4A-4E-0C-67-17",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "IMEI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "IMSI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "889220991389700844qwewqewq",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "75909043503",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "48894397851asdsacxzczxcw",
    "IMSI": "90544253182asdsacxzczxcw",
    "LATITUDE": "23.096117asdasd",
    "LONGITUDE": "112.488113asdasd",
    "MAC": "55-55-64-26-5A-25",
    "MODEL": "baiJAIHlXaaaaaaaaaaaaaaaaaaaaaa",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "56236548327",
    "POWER": "-411",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "F6458F638BF6465997F2DB78BA491294asdwdadzxc",
    "START_TIME": "27:00",
    "STATION": "test-1636616178",
    "S_MAC": "27-76-7D-36-26-23,28-33-78-5A-6B-74",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "CARD_CODE": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于18位。",
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "IMEI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "IMSI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "LATITUDE": "字段格式有误，请检查字段格式，精度少于小数点后6位",
      "LONGITUDE": "字段格式有误，请检查字段格式，精度少于小数点后6位",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "238108406227136980",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "11764368047",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "63791993674",
    "IMSI": "47284305522",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "41-19-16-17-1A-65",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "13612352012",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "DE2CE722B024404F84833FCC637E8390",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "65-15-25-2E-75-18",
    "S_SSID": "fcgz,dmglk",
    "error": {},
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "889660286266975581",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "97467951303",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "11559812591",
    "IMSI": "82717881707",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "0B-6A-5B-02-3E-54",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "27015390391",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "660967A3DEE94DE0A43685175DA99380",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "00-28-0C-4C-01-02,68-37-61-00-1C-49",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "685677147221948102",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "73967164094",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "93060947563",
    "IMSI": "80392787004",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "69-0F-55-1C-4A-2F",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "95152159162",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "1BB2EDAF17074254AFA8ABDA39C7556Dasdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "11-36-35-66-4A-63,6E-23-6B-37-12-61",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "404836102017628519",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "68338747001",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "62554815461",
    "IMSI": "72640078530",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "6A-39-2B-60-30-49",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "92602526296",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "348FE036DFFE4A698C41FFA958EE4BBFasdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "70-29-03-7F-53-49,76-69-1C-7F-7C-7A",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "319968905386866257",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "17260541332",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "91187166541",
    "IMSI": "60948549501",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "2A-70-40-6D-2C-57",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "52186387903",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "BD740786B21A43018D54C07B2DC6B9B5asdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "18-3D-57-2B-7E-62,0A-4E-27-42-11-5B",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "119054125309017233",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "82818336298",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "48956426003",
    "IMSI": "41003669080",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "41-57-51-57-51-00",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "51978031096",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "E2A954170C884B33836D6400874D145Aasdwdadzxc",
    "START_TIME": "00:00",
    "STATION": "test-1636616178",
    "S_MAC": "20-37-5F-3D-74-42,78-38-7C-74-43-0D",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "810883138577086846",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "16875179363",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "13528467478asdsacxzczxcw",
    "IMSI": "61243108555asdsacxzczxcw",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "6B-16-37-2C-1F-24",
    "MODEL": "baiJAIHlXaaaaaaaaaaaaaaaaaaaaaa",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "57221873716",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "90A4C92AB68D443E982A78B257602B01asdwdadzxc",
    "START_TIME": "27:00",
    "STATION": "test-1636616178",
    "S_MAC": "28-60-7F-13-7B-10,03-4A-4E-0C-67-17",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "IMEI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "IMSI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "889220991389700844qwewqewq",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "75909043503",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "48894397851asdsacxzczxcw",
    "IMSI": "90544253182asdsacxzczxcw",
    "LATITUDE": "23.096117asdasd",
    "LONGITUDE": "112.488113asdasd",
    "MAC": "55-55-64-26-5A-25",
    "MODEL": "baiJAIHlXaaaaaaaaaaaaaaaaaaaaaa",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "56236548327",
    "POWER": "-411",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "F6458F638BF6465997F2DB78BA491294asdwdadzxc",
    "START_TIME": "27:00",
    "STATION": "test-1636616178",
    "S_MAC": "27-76-7D-36-26-23,28-33-78-5A-6B-74",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "CARD_CODE": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于18位。",
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "IMEI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "IMSI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "LATITUDE": "字段格式有误，请检查字段格式，精度少于小数点后6位",
      "LONGITUDE": "字段格式有误，请检查字段格式，精度少于小数点后6位",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "238108406227136980",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "11764368047",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "63791993674",
    "IMSI": "47284305522",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "41-19-16-17-1A-65",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "13612352012",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "DE2CE722B024404F84833FCC637E8390",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "65-15-25-2E-75-18",
    "S_SSID": "fcgz,dmglk",
    "error": {},
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "889660286266975581",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "97467951303",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "11559812591",
    "IMSI": "82717881707",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "0B-6A-5B-02-3E-54",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "27015390391",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "660967A3DEE94DE0A43685175DA99380",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "00-28-0C-4C-01-02,68-37-61-00-1C-49",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "685677147221948102",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "73967164094",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "93060947563",
    "IMSI": "80392787004",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "69-0F-55-1C-4A-2F",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "95152159162",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "1BB2EDAF17074254AFA8ABDA39C7556Dasdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "11-36-35-66-4A-63,6E-23-6B-37-12-61",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "404836102017628519",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "68338747001",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "62554815461",
    "IMSI": "72640078530",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "6A-39-2B-60-30-49",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "92602526296",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "348FE036DFFE4A698C41FFA958EE4BBFasdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "70-29-03-7F-53-49,76-69-1C-7F-7C-7A",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "319968905386866257",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "17260541332",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "91187166541",
    "IMSI": "60948549501",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "2A-70-40-6D-2C-57",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "52186387903",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "BD740786B21A43018D54C07B2DC6B9B5asdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "18-3D-57-2B-7E-62,0A-4E-27-42-11-5B",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "119054125309017233",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "82818336298",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "48956426003",
    "IMSI": "41003669080",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "41-57-51-57-51-00",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "51978031096",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "E2A954170C884B33836D6400874D145Aasdwdadzxc",
    "START_TIME": "00:00",
    "STATION": "test-1636616178",
    "S_MAC": "20-37-5F-3D-74-42,78-38-7C-74-43-0D",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "810883138577086846",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "16875179363",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "13528467478asdsacxzczxcw",
    "IMSI": "61243108555asdsacxzczxcw",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "6B-16-37-2C-1F-24",
    "MODEL": "baiJAIHlXaaaaaaaaaaaaaaaaaaaaaa",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "57221873716",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "90A4C92AB68D443E982A78B257602B01asdwdadzxc",
    "START_TIME": "27:00",
    "STATION": "test-1636616178",
    "S_MAC": "28-60-7F-13-7B-10,03-4A-4E-0C-67-17",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "IMEI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "IMSI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "889220991389700844qwewqewq",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "75909043503",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "48894397851asdsacxzczxcw",
    "IMSI": "90544253182asdsacxzczxcw",
    "LATITUDE": "23.096117asdasd",
    "LONGITUDE": "112.488113asdasd",
    "MAC": "55-55-64-26-5A-25",
    "MODEL": "baiJAIHlXaaaaaaaaaaaaaaaaaaaaaa",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "56236548327",
    "POWER": "-411",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "F6458F638BF6465997F2DB78BA491294asdwdadzxc",
    "START_TIME": "27:00",
    "STATION": "test-1636616178",
    "S_MAC": "27-76-7D-36-26-23,28-33-78-5A-6B-74",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "CARD_CODE": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于18位。",
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "IMEI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "IMSI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "LATITUDE": "字段格式有误，请检查字段格式，精度少于小数点后6位",
      "LONGITUDE": "字段格式有误，请检查字段格式，精度少于小数点后6位",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "238108406227136980",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "11764368047",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "63791993674",
    "IMSI": "47284305522",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "41-19-16-17-1A-65",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "13612352012",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "DE2CE722B024404F84833FCC637E8390",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "65-15-25-2E-75-18",
    "S_SSID": "fcgz,dmglk",
    "error": {},
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "889660286266975581",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "97467951303",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "11559812591",
    "IMSI": "82717881707",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "0B-6A-5B-02-3E-54",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "27015390391",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "660967A3DEE94DE0A43685175DA99380",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "00-28-0C-4C-01-02,68-37-61-00-1C-49",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "685677147221948102",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "73967164094",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "93060947563",
    "IMSI": "80392787004",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "69-0F-55-1C-4A-2F",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "95152159162",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "1BB2EDAF17074254AFA8ABDA39C7556Dasdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "11-36-35-66-4A-63,6E-23-6B-37-12-61",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "404836102017628519",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "68338747001",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "62554815461",
    "IMSI": "72640078530",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "6A-39-2B-60-30-49",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "92602526296",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "348FE036DFFE4A698C41FFA958EE4BBFasdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "70-29-03-7F-53-49,76-69-1C-7F-7C-7A",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "319968905386866257",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "17260541332",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "91187166541",
    "IMSI": "60948549501",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "2A-70-40-6D-2C-57",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "52186387903",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "BD740786B21A43018D54C07B2DC6B9B5asdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "18-3D-57-2B-7E-62,0A-4E-27-42-11-5B",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "119054125309017233",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "82818336298",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "48956426003",
    "IMSI": "41003669080",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "41-57-51-57-51-00",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "51978031096",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "E2A954170C884B33836D6400874D145Aasdwdadzxc",
    "START_TIME": "00:00",
    "STATION": "test-1636616178",
    "S_MAC": "20-37-5F-3D-74-42,78-38-7C-74-43-0D",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "810883138577086846",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "16875179363",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "13528467478asdsacxzczxcw",
    "IMSI": "61243108555asdsacxzczxcw",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "6B-16-37-2C-1F-24",
    "MODEL": "baiJAIHlXaaaaaaaaaaaaaaaaaaaaaa",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "57221873716",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "90A4C92AB68D443E982A78B257602B01asdwdadzxc",
    "START_TIME": "27:00",
    "STATION": "test-1636616178",
    "S_MAC": "28-60-7F-13-7B-10,03-4A-4E-0C-67-17",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "IMEI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "IMSI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "889220991389700844qwewqewq",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "75909043503",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "48894397851asdsacxzczxcw",
    "IMSI": "90544253182asdsacxzczxcw",
    "LATITUDE": "23.096117asdasd",
    "LONGITUDE": "112.488113asdasd",
    "MAC": "55-55-64-26-5A-25",
    "MODEL": "baiJAIHlXaaaaaaaaaaaaaaaaaaaaaa",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "56236548327",
    "POWER": "-411",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "F6458F638BF6465997F2DB78BA491294asdwdadzxc",
    "START_TIME": "27:00",
    "STATION": "test-1636616178",
    "S_MAC": "27-76-7D-36-26-23,28-33-78-5A-6B-74",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "CARD_CODE": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于18位。",
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "IMEI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "IMSI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "LATITUDE": "字段格式有误，请检查字段格式，精度少于小数点后6位",
      "LONGITUDE": "字段格式有误，请检查字段格式，精度少于小数点后6位",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "339712072232851613",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "47104496215",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "24:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "96851696858",
    "IMSI": "47468229906",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "29-44-39-47-39-1F",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "WIN",
    "PHONE": "23793087746",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "1902B78ECE034CD9BCF019F29DC93BD3",
    "START_TIME": "00:00",
    "STATION": "test-1636616178",
    "S_MAC": "53-2E-29-7A-49-44",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "339712072232851613",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "47104496215",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "24:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "96851696858",
    "IMSI": "47468229906",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "29-44-39-47-39-1F",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "WIN",
    "PHONE": "23793087746",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "1902B78ECE034CD9BCF019F29DC93BD3",
    "START_TIME": "00:00",
    "STATION": "test-1636616178",
    "S_MAC": "53-2E-29-7A-49-44",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "339712072232851613",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "47104496215",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "24:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "96851696858",
    "IMSI": "47468229906",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "29-44-39-47-39-1F",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "WIN",
    "PHONE": "23793087746",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "1902B78ECE034CD9BCF019F29DC93BD3",
    "START_TIME": "00:00",
    "STATION": "test-1636616178",
    "S_MAC": "53-2E-29-7A-49-44",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "339712072232851613",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "47104496215",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "24:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "96851696858",
    "IMSI": "47468229906",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "29-44-39-47-39-1F",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "WIN",
    "PHONE": "23793087746",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "1902B78ECE034CD9BCF019F29DC93BD3",
    "START_TIME": "00:00",
    "STATION": "test-1636616178",
    "S_MAC": "53-2E-29-7A-49-44",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "339712072232851613",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "47104496215",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "24:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "96851696858",
    "IMSI": "47468229906",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "29-44-39-47-39-1F",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "WIN",
    "PHONE": "23793087746",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "1902B78ECE034CD9BCF019F29DC93BD3",
    "START_TIME": "00:00",
    "STATION": "test-1636616178",
    "S_MAC": "53-2E-29-7A-49-44",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "238108406227136980",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "11764368047",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "63791993674",
    "IMSI": "47284305522",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "41-19-16-17-1A-65",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "13612352012",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "DE2CE722B024404F84833FCC637E8390",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "65-15-25-2E-75-18",
    "S_SSID": "fcgz,dmglk",
    "error": {},
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "889660286266975581",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "97467951303",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "11559812591",
    "IMSI": "82717881707",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "0B-6A-5B-02-3E-54",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "27015390391",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "660967A3DEE94DE0A43685175DA99380",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "00-28-0C-4C-01-02,68-37-61-00-1C-49",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "685677147221948102",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "73967164094",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "93060947563",
    "IMSI": "80392787004",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "69-0F-55-1C-4A-2F",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "95152159162",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "1BB2EDAF17074254AFA8ABDA39C7556Dasdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "11-36-35-66-4A-63,6E-23-6B-37-12-61",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "404836102017628519",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "68338747001",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "62554815461",
    "IMSI": "72640078530",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "6A-39-2B-60-30-49",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "92602526296",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "348FE036DFFE4A698C41FFA958EE4BBFasdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "70-29-03-7F-53-49,76-69-1C-7F-7C-7A",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "319968905386866257",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "17260541332",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "91187166541",
    "IMSI": "60948549501",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "2A-70-40-6D-2C-57",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "52186387903",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "BD740786B21A43018D54C07B2DC6B9B5asdwdadzxc",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "18-3D-57-2B-7E-62,0A-4E-27-42-11-5B",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "119054125309017233",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "82818336298",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "48956426003",
    "IMSI": "41003669080",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "41-57-51-57-51-00",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "51978031096",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "E2A954170C884B33836D6400874D145Aasdwdadzxc",
    "START_TIME": "00:00",
    "STATION": "test-1636616178",
    "S_MAC": "20-37-5F-3D-74-42,78-38-7C-74-43-0D",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "810883138577086846",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "16875179363",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "13528467478asdsacxzczxcw",
    "IMSI": "61243108555asdsacxzczxcw",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "6B-16-37-2C-1F-24",
    "MODEL": "baiJAIHlXaaaaaaaaaaaaaaaaaaaaaa",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "57221873716",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "90A4C92AB68D443E982A78B257602B01asdwdadzxc",
    "START_TIME": "27:00",
    "STATION": "test-1636616178",
    "S_MAC": "28-60-7F-13-7B-10,03-4A-4E-0C-67-17",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "IMEI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "IMSI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "889220991389700844qwewqewq",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "75909043503",
    "DEVICE_MAC": "47-67-3D-7A-76-2Basdwdadzxc",
    "END_TIME": "26:00",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "48894397851asdsacxzczxcw",
    "IMSI": "90544253182asdsacxzczxcw",
    "LATITUDE": "23.096117asdasd",
    "LONGITUDE": "112.488113asdasd",
    "MAC": "55-55-64-26-5A-25",
    "MODEL": "baiJAIHlXaaaaaaaaaaaaaaaaaaaaaa",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "56236548327",
    "POWER": "-411",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "F6458F638BF6465997F2DB78BA491294asdwdadzxc",
    "START_TIME": "27:00",
    "STATION": "test-1636616178",
    "S_MAC": "27-76-7D-36-26-23,28-33-78-5A-6B-74",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "CARD_CODE": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于18位。",
      "DEVICE_MAC": "该字段长度有误，请检查数据是否正确，该字段文档规定长度需为17位。字段格式有误，请检查字段格式，格式应为6个2位大写字母与数字混合以“-”做间隔的数据",
      "END_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "IMEI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "IMSI": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于20位。",
      "LATITUDE": "字段格式有误，请检查字段格式，精度少于小数点后6位",
      "LONGITUDE": "字段格式有误，请检查字段格式，精度少于小数点后6位",
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "START_TIME": "字段格式有误，请检查字段格式，时间戳精度可能不为秒或非时间戳格式",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "238108406227136980",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "11764368047",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "63791993674",
    "IMSI": "47284305522",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "41-19-16-17-1A-65",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "13612352012",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "DE2CE722B024404F84833FCC637E8390",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "65-15-25-2E-75-18",
    "S_SSID": "fcgz,dmglk",
    "error": {},
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  },
  {
    "CARD_CODE": "889660286266975581",
    "COMPANY_ID": "63897199358984",
    "COORDINATE_SYSTEM": "04",
    "DEVICENUM": "97467951303",
    "DEVICE_MAC": "47-67-3D-7A-76-2B",
    "END_TIME": "1636616178",
    "HISTORY_SSID": "awyuut,iphqhgij,afqmlqzw,ohnw",
    "IMEI": "11559812591",
    "IMSI": "82717881707",
    "LATITUDE": "23.096117",
    "LONGITUDE": "112.488113",
    "MAC": "0B-6A-5B-02-3E-54",
    "MODEL": "baiJAIHlX",
    "NAME": "test_man",
    "OS_VERSION": "YLPzb",
    "PHONE": "27015390391",
    "POWER": "-41",
    "SERVICECODE": "74609542151040",
    "SESSION_ID": "660967A3DEE94DE0A43685175DA99380",
    "START_TIME": "1636616178",
    "STATION": "test-1636616178",
    "S_MAC": "00-28-0C-4C-01-02,68-37-61-00-1C-49",
    "S_SSID": "fcgz,dmglk",
    "error": {
      "PHONE": "字段格式有误，请检查字段格式，手机不允许存在非数字字符或手机号格式存在问题",
      "S_MAC": "该字段长度有误，请查阅文档并检查该字段，该字段文档规定长度不少于17位。"
    },
    "file": "/opt/filecenter/ftp/autotest/szgd/DWZM/20211111/15/20210727164547_559_440305_980609862_07.log"
  }
]